import script from "./cardVue.vue?vue&type=script&setup=true&lang=js"
export * from "./cardVue.vue?vue&type=script&setup=true&lang=js"

import "./cardVue.vue?vue&type=style&index=0&id=38c71da1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38c71da1"]])

export default __exports__